<template>
  <section class="home-bed">
    <div class="img-bed">
      <black-bar title="常见问题">
      </black-bar>
    </div>
    <div class="content" v-html="src">
    </div>
  </section>
</template>

<script>
import blackBar from '@/components/blackBar'
import { questionDetail } from '../api/data.js'

export default {
  name: 'questionDetail',
  data () {
    return {
      loading: true,
      questionId: '',
      src: ''
    }
  },
  components: {
    blackBar
  },
  created () {
    // if (window.sessionStorage.getItem('token')) {
    //   this.loading = true
    // }
  },
  mounted () {
    if (this.$route.params) {
      this.questionId = this.$route.params.questionId;
    }
    questionDetail(this.questionId).then(res => {
      if(res.data.code === 200) {
        const data = JSON.parse(res.data.data)
        console.log(data)
        this.src = data.content
        console.log(this.src)
      }else {

      }
    })
  },
  methods: {
    // selectItem (index) {
    //   this.typeNum = index;
    // },
    test() {
        console.log('sss',this.src)
        render:(h)=> {
            h(
                'p',
                [
                    this.src
                ]
            )
        }
    }
    // goRouter (router) {
    //   if (this.loading) {
    //     this.$router.push({
    //       name: router
    //     })
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
.home-bed {
  // background: #eee;
  min-height: 100%;
  overflow: scroll;
  position: relative;
  text-align: center;
  background-color: #f5f5f5;
}
.img-bed {
  font-size: 0;
  margin-bottom: 12px;
  background: #fff;
  position: relative;
  width: 100%;
  // height: 320px;
  > div {
    position: absolute;
    margin: 0 auto;
    width: 100%;
    padding: 20px 0;
    text-align: center;
    background-color: #666;
  }
  img {
    width: 100%;
  }
}
.cardInfo {
  width: 92%;
  margin-left: 4%;
  position: relative;
  img {
    width: 100%;
  }
  .word {
    position: absolute;
    top: 50%;
    left: 64px;
    margin-top: -28px;
    width: 100%;
    height: 56px;
    line-height: 56px;
    font-size: 40px;
    font-weight: 500;
    color: #ffffff;
    text-align: left;
  }
}
.content {
    width: 100%;
    height: 800px;
    iframe {
        width: 100%;
        height: 100%;
    }
}
</style>
